import { DXF_GeoJson_Parser } from '../hooks/helper'
import { LineString } from './threeLinestring'
import { Triangle } from './threeTriangle'

export class ViewAsDigs {

    cfg: iArgs
    line: LineString
    triangle: Triangle
    obj: any = {}

    constructor(cfg: iArgs) {

        this.cfg = cfg
        this.line = new LineString({ Maptalks: cfg.MapView })
        this.triangle = new Triangle({ Maptalks: cfg.MapView })

    }

    remove = (key = '') => {

        this.triangle.remove(key)
        this.line.remove(key)

    }

    remove_all = () => {
        this.triangle.remove_all()
        this.line.remove_all()
    }

    render_plan = (key = '', name = '', dst = '') => new Promise<{}>((res) => {

        this.cfg.core_data.poll('get-chunks-merged', { name, dst }, (e: any, data: any = {}) => {

            if (e) { res({}) } else {

                const { polygons, linestrings, points } = DXF_GeoJson_Parser(data)

                /* console.log(name)
                console.log(data)
                console.log(polygons)
                console.log(linestrings) */

                this.triangle.insert(key, polygons)
                this.line.insert(key, linestrings)

                res({ polygons, linestrings, points })

            }

        })

    })

    addWithFilter = (key: string, ref = 'UTM', res: any[]) => {

        const obj: any = {}

        for (const x of res) {

            const { qr, rows } = x

            if (qr.path === 'get-chunks-merged') {

                const { polygons, linestrings, points } = DXF_GeoJson_Parser(rows)
                this.triangle.insert(key, polygons)
                this.line.insert(key, linestrings)

            }

            if (qr.path === 'get-events-shot-actual') {

                const acts: any = {}
                for (const x of rows) {
                    const shot = JSON.parse(x.data)
                    acts[shot.holeId] = shot
                }

                obj['actual'] = acts

            }

        }

        // this.render_all(key, obj)

    }

    removeStartsWith = (key: string) => {

        if (this.obj) for (const x in this.obj) if (x.indexOf(key) === 0) {

            this.cfg.MapView?.threeLayer.removeMesh(this.obj[x])
            delete this.obj[x]

        }

    }

}